import type { Theme } from "@mui/material";
import type { SystemStyleObject } from "@mui/system";

// Every style below is the plain object form rather than `SxProps`, which can also be an array or a
// function: only the object form can be spread, and the header cells do exactly that to merge in
// their column width.

/**
 * Every group renders its own table, so the column widths have to be pinned rather than derived from
 * each table's own content — otherwise the columns of the stacked tables do not line up.
 */
export const columnWidths = ["10%", "28%", "16%", "26%", "20%"] as const;

/** Below this the fixed columns would squash; the container scrolls instead. */
const MIN_TABLE_WIDTH = 720;

export const tableSx: SystemStyleObject<Theme> = {
  tableLayout: "fixed",
  minWidth: MIN_TABLE_WIDTH,
};

/** Uppercase small-caps column headers on a muted surface, as in the report mockup. */
export const headerCellSx: SystemStyleObject<Theme> = {
  bgcolor: "action.hover",
  color: "text.secondary",
  fontWeight: 700,
  fontSize: "0.75rem",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  whiteSpace: "nowrap",
};

export const notAssignedSx: SystemStyleObject<Theme> = {
  fontStyle: "italic",
  color: "text.secondary",
};
